import React from 'react';
import clsx from 'clsx';
export const BlockIcon = ({ color, accessibilityLabel, className, children, size, }) => {
    const iconWrapperSize = [
        size === 'xs' && 'h-4 w-4',
        size === 'sm' && 'h-8 w-8',
        size === 'md' && 'h-10 w-10',
        size === 'lg' && 'h-12 w-12',
    ];
    const colorClsx = [
        color === 'default' && 'text-content-subdued',
        color === 'primary' && 'text-action-primary',
        color === 'positive' && 'text-content-on-positive',
        color === 'negative' && 'text-content-on-negative',
        color === 'attention' && 'text-content-on-attention',
        color === 'highlight' && 'text-content-on-highlight',
    ];
    return (React.createElement("span", { className: clsx(className, iconWrapperSize, colorClsx, 'inline-block m-0 box-border') },
        accessibilityLabel && (React.createElement("span", { className: "sr-only" }, accessibilityLabel)),
        children));
};
//# sourceMappingURL=BlockIcon.js.map